import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { resetFlashMessage } from '../redux/flash/actions';
import { getFlashMessage, getFlashShow, getFlashType, getFlashDuration } from '../redux/selectors';

import alertred from '../assets/icons/alert-red.svg';
import close from '../assets/icons/ic-close.svg';
import './Flash.css';

class Flash extends Component {
  constructor(props) {
    super(props);
    this.timer = null;
    this.state = {
      message: props.message || '',
      open: false,
      type: props.type,
      autoHideDuration: props.autoHideDuration,
    };
  }
  componentWillReceiveProps(nextProps) {
    this.clearTimer();
    this.setState({
      message: nextProps.message,
      open: nextProps.show,
      type: nextProps.type,
      autoHideDuration: nextProps.autoHideDuration,
    }, () => {
      if (this.state.autoHideDuration > 0) {
        if (nextProps.show) {
          this.timer = setTimeout(() => {
            this.close();
          }, this.state.autoHideDuration);
        }
      }
    });
  }
  componentWillUnmount() {
    this.close();
  }
  clearTimer() {
    clearTimeout(this.timer);
  }
  close() {
    this.clearTimer();
    const { store } = this.context;
    store.dispatch(resetFlashMessage());
  }
  handleClose = (event) => {
    event.preventDefault();
    this.close();
  }
  render() {
    return (
      <button className={`Flash ${this.state.type} ${this.state.open ? 'show' : 'hide'}`} onClick={this.handleClose}>
        <span>
          {this.state.type === 'error' ? <img src={alertred} alt="error" /> : null}
          <p>{this.state.message}</p>
          <img className="close-icon" alt="close" src={close} />
        </span>
      </button>
    );
  }
}

Flash.propTypes = {
  message: PropTypes.string,
  type: PropTypes.string,
  show: PropTypes.string,
  autoHideDuration: PropTypes.number,
};

Flash.defaultProps = {
  message: null,
  type: null,
  show: false,
  autoHideDuration: 7000,
};

Flash.contextTypes = {
  store: PropTypes.object,
};

const mapStateToProps = state => ({
  message: getFlashMessage(state),
  show: getFlashShow(state),
  type: getFlashType(state),
  autoHideDuration: getFlashDuration(state),
});

export default connect(mapStateToProps)(Flash);



// WEBPACK FOOTER //
// ./src/components/Flash.jsx